import { AbstractDTO } from "@signature-it/ngx-generic/models";
import { IGetTemporaryTransactionResponse } from "@signature-it/ngx-catalogue/interfaces";

export class GetTemporaryTransactionDTO extends AbstractDTO implements IGetTemporaryTransactionResponse {

    TransactionNumber: string;
    Transaction: object;
    CreateOrUpdatePOSCustomerErrorCode: number;
    TransactionItemErrorCode: number;
    TransactionItemErrorLine: number;
    CreditCardErrorCode: number;
    CreditCardErrorLine: number;
    CreateShipmentErrorCode: number;
    TemporaryTransactionNumber: string;
    ClubMembership: object;
    CreateCouponErrorCode: number;
    CouponCodeError: string;
    UsePointsErrorCode: string;
    ErrorCode: number;


    constructor(attributes: Object) {
        super( attributes );
        this.TransactionNumber = attributes['TransactionNumber'];
        this.Transaction = attributes['Transaction'];
        this.CreateOrUpdatePOSCustomerErrorCode = attributes['CreateOrUpdatePOSCustomerErrorCode'];
        this.TransactionItemErrorCode = attributes['TransactionItemErrorCode'];
        this.TransactionItemErrorLine = attributes['TransactionItemErrorLine'];
        this.CreditCardErrorCode = attributes['CreditCardErrorCode'];
        this.CreditCardErrorLine = attributes['CreditCardErrorLine'];
        this.CreateShipmentErrorCode = attributes['CreateShipmentErrorCode'];
        this.TemporaryTransactionNumber = attributes['TemporaryTransactionNumber'];
        this.ClubMembership = attributes['ClubMembership'];
        this.CreateCouponErrorCode = attributes['CreateCouponErrorCode'];
        this.CouponCodeError = attributes['CouponCodeError'];
        this.UsePointsErrorCode = attributes['UsePointsErrorCode'];
        this.ErrorCode = attributes['ErrorCode'];
    }

    hasItems() {
        return this.Transaction && this.Transaction['TransactionItems'] && this.Transaction['TransactionItems'].length;
    }
}
